import {
  businessActivitiesService,
  type BusinessActivity,
} from '@/services/business-activities';
import { useDebouncedValue } from '@/shared/utils/use-filters.hook';
import { useQuery } from '@tanstack/react-query';

type UseBusinessActivitiesParams = {
  search?: string;
  pageSize?: number;
  enabled?: boolean;
};

export function useBusinessActivities({
  search = '',
  pageSize = 1000,
  enabled = true,
}: UseBusinessActivitiesParams = {}) {
  const debouncedSearch = useDebouncedValue(search, 300);

  return useQuery<BusinessActivity[], Error>({
    queryKey: ['business-activities', debouncedSearch, pageSize],
    queryFn: async () => {
      const response = await businessActivitiesService.getBusinessActivities({
        filter: debouncedSearch || undefined,
        pageNumber: 1,
        pageSize,
      });

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar atividades empresariais'
        );
      }

      return response.data.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
